/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';

/**
 * 
 * @export
 * @interface EnumerationValueListDto
 */
export interface EnumerationValueListDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueListDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationValueListDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<EnumerationOptionDto>}
     * @memberof EnumerationValueListDto
     */
    selectedOptions?: Array<EnumerationOptionDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueListDto
     */
    isUsedForEvaluation?: boolean;
    /**
     * 
     * @type {Array<EnumerationOptionDto>}
     * @memberof EnumerationValueListDto
     */
    options?: Array<EnumerationOptionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueListDto
     */
    $type?: EnumerationValueListDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationValueListDtoTypeEnum = typeof EnumerationValueListDtoTypeEnum[keyof typeof EnumerationValueListDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationValueListDto interface.
 */
export function instanceOfEnumerationValueListDto(value?: unknown): value is EnumerationValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationValueListDtoTypeEnum)[0];
}

export function EnumerationValueListDtoFromJSON(json: any): EnumerationValueListDto {
    return EnumerationValueListDtoFromJSONTyped(json, false);
}

export function EnumerationValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationValueListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'selectedOptions': !exists(json, 'selectedOptions') ? undefined : (json['selectedOptions'] === null ? null : (json['selectedOptions'] as Array<any>).map(EnumerationOptionDtoFromJSON)),
        'isUsedForEvaluation': !exists(json, 'isUsedForEvaluation') ? undefined : json['isUsedForEvaluation'],
        'options': !exists(json, 'options') ? undefined : (json['options'] === null ? null : (json['options'] as Array<any>).map(EnumerationOptionDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationValueListDtoToJSON(value?: EnumerationValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'selectedOptions': value.selectedOptions === undefined ? undefined : (value.selectedOptions === null ? null : (value.selectedOptions as Array<any>).map(EnumerationOptionDtoToJSON)),
        'isUsedForEvaluation': value.isUsedForEvaluation,
        'options': value.options === undefined ? undefined : (value.options === null ? null : (value.options as Array<any>).map(EnumerationOptionDtoToJSON)),
        '$type': value.$type,
    });
}

